const ProgressBar = ({
  percentage = 0,
  label = "",
  showPercentage = false,
  progressBarHeight = "6px",
}) => {
  // clamp between 0 and 100
  const clamped = Math.min(100, Math.max(0, percentage));

  return (
    <div style={{ width: "100%" }}>
      {/* Label + optional percentage text */}
      {label && (
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
          <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#212121" }}>{label}</span>
          {showPercentage && (
            <span style={{ fontSize: "0.8rem", color: "#757575" }}>{clamped}%</span>
          )}
        </div>
      )}

      {/* Track */}
      <div
        style={{
          width: "100%",
          // height: "6px",
          height: progressBarHeight,
          backgroundColor: "#e0e0e0",
          borderRadius: "999px",
          overflow: "hidden",
        }}
      >
        {/* Fill */}
        <div
          style={{
            width: `${clamped}%`,
            height: "100%",
            backgroundColor: "#1976d2",
            borderRadius: "999px",
            transition: "width 0.4s ease",
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
